<template>
  <div class="display-contents">
    <router-view />
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/main.scss';
</style>
<style>
@import '@/assets/css/main.css';
</style>
